/**
 * Guide metadata and content mapping for each role.
 * Each guide has: key, title, subtitle, filename (for PDF download), and roles that can see it.
 */

export const GUIDES = [
  {
    key: 'chofer',
    title: 'Guía del Chofer',
    subtitle: 'Módulo de Gastos — Subir, enviar y dar seguimiento a recibos',
    filename: 'Guia_Chofer.pdf',
    roles: ['employee', 'admin'],
    icon: '🧾',
    sections: [
      'Iniciar sesión en el portal',
      'Pantalla principal — Mis Recibos',
      'Subir un recibo nuevo (imagen + IA)',
      'Completar datos y partidas',
      'Guardar como borrador',
      'Enviar para revisión',
      'Consultar el estado de un recibo',
      'Corregir un recibo devuelto',
    ],
  },
  {
    key: 'supervisor',
    title: 'Guía del Supervisor',
    subtitle: 'Módulo de Nómina — Crear y enviar tarjetas de tiempo',
    filename: 'Guia_Supervisor.pdf',
    roles: ['supervisor', 'admin'],
    icon: '⏱️',
    sections: [
      'Pantalla principal de Nómina',
      'Crear una tarjeta de tiempo nueva',
      'Registrar horas por trabajador',
      'Regla de las 8 horas entre proyectos',
      'Guardar y enviar la tarjeta',
      'Copiar una tarjeta existente',
      'Corregir una tarjeta devuelta',
      'Consultar el historial',
    ],
  },
  {
    key: 'aprobacion',
    title: 'Guía de Aprobación — Ingeniero y Gerente',
    subtitle: 'Aprobación de Gastos (L1) y Nómina (L1/L2)',
    filename: 'Guia_Aprobacion.pdf',
    roles: ['engineer', 'manager', 'admin'],
    icon: '✅',
    sections: [
      'Entender los niveles de aprobación',
      'Proyectos de 2 niveles vs 3 niveles',
      'Gastos — Codificar recibos (Código + GL)',
      'Gastos — Aprobar, devolver y rechazar partidas',
      'Gastos — Acciones masivas y dividir partidas',
      'Nómina — Revisar y aprobar tarjetas (Ingeniero L1)',
      'Nómina — Aprobar tarjetas (Gerente L2)',
      'Crear tarjetas de tiempo y envío inteligente',
    ],
  },
  {
    key: 'revision',
    title: 'Guía de Revisión Final',
    subtitle: 'Aprobación final de Gastos y Nómina',
    filename: 'Guia_Revision_Final.pdf',
    roles: ['reviewer', 'admin'],
    icon: '🔍',
    sections: [
      'Su rol como última línea de aprobación',
      'Gastos — Revisar y aprobar recibos',
      'Gastos — Editar campos antes de aprobar',
      'Gastos — Devolver o rechazar recibos',
      'Nómina — Revisar tarjetas pendientes',
      'Nómina — Validación AMGtime',
      'Nómina — Aprobar o devolver tarjetas',
      'Crear tarjetas de tiempo',
    ],
  },
  {
    key: 'contabilidad',
    title: 'Guía de Contabilidad',
    subtitle: 'Exportación y consulta de Gastos y Nómina aprobados',
    filename: 'Guia_Contabilidad.pdf',
    roles: ['accountant', 'admin'],
    icon: '📊',
    sections: [
      'Portal de Contabilidad — Vista general',
      'Gastos Aprobados — Consultar y filtrar',
      'Exportar Gastos a CSV (Sage 50)',
      'Marcar gastos como pagados',
      'Nómina Aprobada — Consultar y filtrar',
      'Exportar Nómina a CSV (Sage 50)',
      'Historial de exportaciones',
    ],
  },
  {
    key: 'administrador',
    title: 'Guía del Administrador',
    subtitle: 'Administración completa de la plataforma',
    filename: 'Guia_Administrador.pdf',
    roles: ['admin'],
    icon: '⚙️',
    sections: [
      'Dashboard — Estadísticas y gráficos',
      'Gastos — Aprobar como administrador',
      'Nómina — Editar tarjetas aprobadas',
      'Configuración — Usuarios y roles',
      'Configuración — Empleados (Personas)',
      'Configuración — Proyectos y Gangas',
      'Configuración — Tablas de referencia',
      'Configuración — Ajustes del sistema',
      'Reportes y exportaciones Sage 50',
    ],
  },
];

/**
 * Returns guides visible to a user based on their roles array.
 * Admin sees all guides.
 */
export function getGuidesForUser(user) {
  if (!user || !user.roles) return [];
  const isAdmin = user.roles.includes('admin');
  if (isAdmin) return GUIDES;
  return GUIDES.filter(g =>
    g.roles.some(r => user.roles.includes(r))
  );
}
